<template>
  <modal
    name="videoPlayModal"
    :click-to-close="false"
    :width="1040"
    :height="'auto'"
    @before-open="beforeOpen"
  >
    <div class="video-play-modal">
      <div class="play-modal-header">
        <span>{{ item.name }}</span>
        <div @click="close">
          <iconfont
            class="normal"
            style="font-size:14px;"
            name="#icon20-12guanbianniujiaohu"
            color="#666666"
          ></iconfont>
          <iconfont
            class="hover"
            style="font-size:14px;"
            name="#icon20-12guanbianniujiaohu"
            color="#9e9e9e"
          ></iconfont>
        </div>
      </div>
      <div class="play-modal-body">
        <video
          :src="$.handleAssetsUrl(item.url)"
          :poster="$.handleAssetsUrl(item.cover)"
          autoplay
          controlslist="nodownload"
          controls="controls"
        ></video>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'VideoPlayModal',
  data() {
    return {
      item: {}
    };
  },
  methods: {
    beforeOpen(info) {
      this.item = info.params;
    },
    close() {
      this.$modal.hide('videoPlayModal');
    }
  }
};
</script>
<style lang="scss" scoped>
.video-play-modal {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.play-modal-header {
  padding: 20px 20px 10px;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  > span {
    line-height: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #303133;
  }

  > div {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;

    .hover {
      display: none;
    }

    &:hover {
      .normal {
        display: none;
      }
      .hover {
        display: block;
      }
    }
  }
}
.play-modal-body {
  padding: 10px 20px 19px;
  width: 100%;
  height: 563px;

  video {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border: 1px solid #d2d4de;
  }
}
</style>
